// frontend/src/core/api/health.js

// Health probe. Does not throw — callers distinguish ok / degraded / unreachable.
import { API_BASE_URL } from './client';

export const fetchHealth = async () => {
  try {
    const res = await fetch(`${API_BASE_URL}/api/health`);
    return { ok: res.ok, status: res.status };
  } catch {
    return { ok: false, status: 0 };
  }
};